<!-- <template>
  <el-drawer
      title="分配任务"
      :visible.sync="visible"
      direction="rtl"
      size="80%"
      :destroy-on-close="true"
      :before-close="handleClose"
    >
    分配任务弹窗
    </el-drawer>
</template>
<script>
export default {
  name:'AssignSampleTask',
  props:{
    visible:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return {
      
    }
  },
  methods:{
    handleClose(){
      this.$emit('handleClose',false);
    }
  },
  mounted(){

  },
}
</script> -->
<template>
  <div>
    <el-drawer
      :title="type === 'add' ? '添加任务' : '编辑任务'"
      :visible="visible"
      :size="1280"
      :destroy-on-close="true"
      :before-close="customCloseDrawer"
    >
      <div class="flex">
        <div class="left" :style="{ flex:'auto',width: 'calc(100% - 330px)' }">
          <div class="demo-drawer__content">
            <el-form :model="taskForm" :rules="rules" ref="taskRuleForm" label-width="100px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="调查员：">
                    <span>{{ rowData.agentName || taskForm.executorName }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="手机号码：">
                    <span>{{ rowData.phone || taskForm.executorPhone }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :style="{ marginBottom: '0' }" label="结算类型：" prop="settleMethod">
                    <div class="flex">
                      <div class="inline-block">
                        <div class="btn-box btn1 box-border" :class="{ 'btn-checked': btnChecked == 'online' }" @click="changeSettleMethod('online')">
                          <el-checkbox class="position-checkbox" :disabled = "!(btnChecked == 'online')" :value="true"></el-checkbox>
                          <div>
                            <div class="text-theme-black-650 text-medium mb-2 font-semibold">线上结算
                              <div class="tujian bg-yellow-theme text-white inline-block text-center font-semibold text-small">
                                推荐
                              </div>
                            </div>
                            <div class="text-theme-black-450 text-small">线上支付调查员费用，调研工厂代调查员纳税，并为您的总花费开具发票</div>
                            <div class="flex justify-between mt-1" v-if="!isOpen">
                              <span class="text-yellow-theme text-small">
                                <i class="iconfont icon-jingshishuoming text-small font-semibold"></i>
                                尚未开通，无法使用
                              </span>
                              <span class="cursor-pointer text-theme text-small" @click="toOpen">去开通></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="inline-block">
                        <div class="btn-box btn2 box-border" :class="{ 'btn-checked': btnChecked == 'offline' }" @click="changeSettleMethod('offline')">
                          <el-checkbox class="position-checkbox" :disabled = "!(btnChecked == 'offline')" :value="true"></el-checkbox>
                          <div>
                            <div class="text-theme-black-650 text-medium mb-2 font-semibold">线下结算</div>
                            <div class="text-theme-black-450 text-small">常用场景：线下与调查员签署劳务协议、协商支付方式、纳税事宜等</div>
                          </div>
                        </div>
                      </div>
                      <div class="inline-block">
                        <div class="btn-box btn2 box-border" :class="{ 'btn-checked': btnChecked == 'neednot' }" @click="changeSettleMethod('neednot')">
                          <el-checkbox class="position-checkbox" :disabled = "!(btnChecked == 'neednot')" :value="true"></el-checkbox>
                          <div>
                            <div class="text-theme-black-650 text-medium mb-2 font-semibold">无需结算</div>
                            <div class="text-theme-black-450 text-small">常用场景：已同调查员签署劳动合同或调查员愿提供无偿服务等</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="18">
                  <el-form-item :style="{ marginBottom: taskForm.settleMode ? '0' : '18px' }" label="结算方式：" prop="settleMode">
                    <el-radio-group v-model="taskForm.settleMode" @change="changeSettlementType" :disabled="(!isOpen&&taskForm.settleMethod==0)">
                      <el-radio :label="1">按答卷数量</el-radio>
                      <el-radio :label="2">按天</el-radio>
                      <el-radio v-if="!(btnChecked == 'neednot')" :label="3">按阶梯计价</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <div class="settlementType-style" v-if="taskForm.settleMode === 1">
                    <div class="flex-box" v-if="taskForm.settleMethod!=2">
                      <el-form-item
                        label="单价（元）:"
                        prop="settleRule.unitPriceYuan"
                        :rules="[{ required: !((!isOpen&&taskForm.settleMethod==0)||taskForm.settleMethod==2), message: ' ', trigger: 'blur' }]"
                      >
                        <el-input-number
                          placeholder=""
                          v-model="taskForm.settleRule.unitPriceYuan"
                          autocomplete="off"
                          controls-position="right"
                          :min="1"
                          :max="Infinity"
                          :precision="2"
                          :disabled="(!isOpen&&taskForm.settleMethod==0)||taskForm.settleMethod==2"
                        >
                        </el-input-number>
                      </el-form-item>
                      <span>元</span>
                    </div>
                    <div class="settlement-tips" v-if="taskForm.settleMethod!=2">
                      若用线上结算，请填写调查员到手金额，到手金额
                      <el-button type="text" @click="dialVisible = true">计算器</el-button>
                    </div>
                    <div class="flex-box">
                      <span class="pos-abs-box">
                        <i>*</i>
                        答卷数量:
                        <el-tooltip
                          effect="dark"
                          content="该数量仅为参考回收数量，调查员可超额上报答卷，您可与调查员线下协商上报数量，采用线上结算时，可按照实际上报答卷数量进行结算"
                          placement="top"
                        >
                          <div class="icon-wrap" style="margin-left: 4px">
                            <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                          </div>
                        </el-tooltip>
                      </span>
                      <el-form-item
                        label=""
                        prop="settleRule.expectedQuantity"
                        :rules="[{ required: !((!isOpen&&taskForm.settleMethod==0)), message: ' ', trigger: 'blur' }]"
                      >
                        <el-input-number
                          placeholder=""
                          v-model="taskForm.settleRule.expectedQuantity"
                          autocomplete="off"
                          controls-position="right"
                          :min="1"
                          :max="Infinity"
                          :precision="0"
                          :disabled="(!isOpen&&taskForm.settleMethod==0)"
                        >
                        </el-input-number>
                      </el-form-item>
                      <span>份</span>
                    </div>
                    <div class="settlement-tips" style="margin-bottom: 0" v-if="taskForm.settleMethod!=2">
                      <div style="display: flex">
                        <div>预估费用：{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalSaleYuan }}元</div>
                        <el-tooltip
                          effect="dark"
                          :content="`项目预计费用=预估费用*（1+${accRate}），其中${accountingRateVal}为用于调查员待缴税及平台技术服务费`"
                          placement="top"
                        >
                          <div class="icon-wrap" style="margin-left: 4px">
                            <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                          </div>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                  <div class="settlementType-style" v-if="taskForm.settleMode === 2">
                    <div class="flex-box" v-if="taskForm.settleMethod!=2">
                      <el-form-item
                        label="单价（元）:"
                        prop="settleRule.unitPriceYuan"
                        :rules="[{ required: !((!isOpen&&taskForm.settleMethod==0)||taskForm.settleMethod==2), message: ' ', trigger: 'blur' }]"
                      >
                        <el-input-number
                          placeholder=""
                          v-model.number="taskForm.settleRule.unitPriceYuan"
                          autocomplete="off"
                          controls-position="right"
                          :min="1"
                          :max="Infinity"
                          :precision="2"
                          :disabled="(!isOpen&&taskForm.settleMethod==0)||taskForm.settleMethod==2"
                        >
                        </el-input-number>
                      </el-form-item>
                      <span>元</span>
                    </div>
                    <div class="settlement-tips" v-if="taskForm.settleMethod!=2">
                      若用线上结算，请填写调查员到手金额，到手金额
                      <el-button type="text" @click="dialVisible = true">计算器</el-button>
                    </div>
                    <div class="flex-box">
                      <span class="pos-abs-box">
                        <i>*</i>
                        天数:
                        <el-tooltip
                          effect="dark"
                          content="当天只要上报答卷即记为工作 1 天，该天数仅为参考工作天数，您可与调查员线下协商工作天数，采用线上结算时，可按照实际工作天数进行结算"
                          placement="top"
                        >
                          <div class="icon-wrap" style="margin-left: 4px">
                            <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                          </div>
                        </el-tooltip>
                      </span>
                      <el-form-item
                        label=""
                        prop="settleRule.expectedQuantity"
                        :rules="[{ required: !((!isOpen&&taskForm.settleMethod==0)), message: ' ', trigger: 'blur' }]"
                      >
                        <el-input-number
                          placeholder=""
                          v-model.number="taskForm.settleRule.expectedQuantity"
                          autocomplete="off"
                          controls-position="right"
                          :min="1"
                          :max="Infinity"
                          :precision="0"
                          :disabled="(!isOpen&&taskForm.settleMethod==0)"
                        >
                        </el-input-number>
                      </el-form-item>
                      <span>天</span>
                    </div>
                    <div class="settlement-tips" style="margin-bottom: 0" v-if="taskForm.settleMethod!=2">
                      <div style="display: flex">
                        <div>预估费用：{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalSaleYuan }}元</div>
                        <el-tooltip
                          effect="dark"
                          :content="`项目预计费用=预估费用*（1+${accRate}），其中${accountingRateVal}为用于调查员待缴税及平台技术服务费`"
                          placement="top"
                        >
                          <div class="icon-wrap">
                            <span class="icon-font ico-tips">&#xe65b;</span>
                          </div>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                  <div class="settlementType-style" v-if="taskForm.settleMode === 3">
                    <el-form-item class="is-require-task" style="margin-bottom: 0" label="单价（元）:" v-if="taskForm.settleMethod != 2">
                      <div
                        class="flex-settlement"
                        v-for="(item, index) in taskForm.settleRule.tiers"
                        :key="index"
                        :style="{ marginBottom: index === taskForm.settleRule.tiers.length - 1 ? '0px' : '5px' }"
                      >
                        <span style="margin-right: 8px" v-show="index === 0">每天</span>
                        <el-form-item label>
                          <el-input-number
                            v-if="index === 0"
                            :disabled="true"
                            placeholder=""
                            v-model="item.quantityLowerBound"
                            autocomplete="off"
                            controls-position="right"
                            :min="0"
                            :max="Infinity"
                            :precision="0"
                          >
                          </el-input-number>
                          <el-input-number
                            v-if="index > 0"
                            :disabled="true"
                            placeholder=""
                            :value="taskForm.settleRule.tiers[index - 1].quantityUpperBound * 1"
                            autocomplete="off"
                            controls-position="right"
                            :min="0"
                            :max="Infinity"
                            :precision="0"
                          >
                          </el-input-number>
                        </el-form-item>
                        <span style="margin: 0 8px">份 &lt; 完成量 ≤</span>
                        <el-form-item
                          label
                          :prop="'settleRule.tiers[' + index + '].quantityUpperBound'"
                          :rules="[{ required: !((!isOpen&&taskForm.settleMethod==0)||taskForm.settleMethod==2), message: ' ', trigger: 'blur' }]"
                        >
                          <el-input-number
                            placeholder=""
                            v-model="item.quantityUpperBound"
                            autocomplete="off"
                            controls-position="right"
                            :min="index > 0 ? taskForm.settleRule.tiers[index - 1].quantityUpperBound * 1 + 1 : 1"
                            :max="Infinity"
                            @change="val => currentInputNumber(val, item, index)"
                            :precision="0"
                            :disabled="(!isOpen&&taskForm.settleMethod==0)||taskForm.settleMethod==2"
                          >
                          </el-input-number>
                        </el-form-item>
                        <span style="margin: 0 8px">份，按完成量</span>
                        <el-form-item
                          label
                          :prop="'settleRule.tiers[' + index + '].unitPriceYuan'"
                          :rules="[
                            {
                              required: !((!isOpen&&taskForm.settleMethod==0)||taskForm.settleMethod==2),
                              message: ' ',
                              trigger: 'blur'
                            }
                          ]"
                          style="margin-left: 10px"
                        >
                          <el-input-number
                            placeholder=""
                            v-model.number="item.unitPriceYuan"
                            autocomplete="off"
                            controls-position="right"
                            :min="1"
                            :max="Infinity"
                            :precision="2"
                            :disabled="(!isOpen&&taskForm.settleMethod==0)||taskForm.settleMethod==2"
                          >
                          </el-input-number>
                        </el-form-item>
                        <span style="margin-left: 8px">元/份</span>
                        <el-button v-if="index === 0" @click="handleSettlement('add', index)" class="btn-style" type="text"
                          ><i class="icon-font">&#xe68c;</i></el-button
                        >
                        <el-button
                          v-else-if="index === taskForm.settleRule.tiers.length - 1"
                          @click="handleSettlement('remove', index)"
                          class="btn-style"
                          type="text"
                          ><i class="icon-font">&#xe68a;</i></el-button
                        >
                        <!-- <el-button @click="handleSettlement(index=== taskForm.ladderSettlement.length-1 ? 'add' : 'remove')" class="btn-style" type="text"> {{index=== 0? '+':'-'}}</el-button> -->
                      </div>
                      <div class="settlement-tips left-0">
                        若用线上结算，请填写调查员到手金额，到手金额
                        <el-button type="text" @click="dialVisible = true">计算器</el-button>
                      </div>
                    </el-form-item>
                    <div class="flex-box">
                      <el-form-item
                        style="margin-bottom: 0"
                        label="天数:"
                        prop="settleRule.expectedQuantity"
                        :rules="[{ required: !((!isOpen&&taskForm.settleMethod==0)), message: ' ', trigger: 'blur' }]"
                      >
                        <el-input-number
                          placeholder=""
                          v-model.number="taskForm.settleRule.expectedQuantity"
                          autocomplete="off"
                          controls-position="right"
                          :min="1"
                          :max="Infinity"
                          :precision="0"
                          :disabled="(!isOpen&&taskForm.settleMethod==0)"
                        >
                        </el-input-number>
                      </el-form-item>
                      <span>天</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="14">
                  <el-form-item label="任务名称：" prop="executionName">
                    <el-input placeholder="请输入任务名称" v-model="taskForm.executionName" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="截止时间：" prop="executionValidateTo">
                    <el-date-picker
                      type="datetime"
                      placeholder="选择时间"
                      v-model="taskForm.executionValidateTo"
                      style="width: 100%"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item label="描述：" prop="executionDescription">
                    <el-input placeholder="请输入描述" v-model="taskForm.executionDescription" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="执行要求：" prop="executionRequirement">
                    <el-input placeholder="请输入执行要求" v-model="taskForm.executionRequirement" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="质控标准：" prop="qualityControlStandard">
                    <el-input placeholder="请输入质控标准" v-model="taskForm.qualityControlStandard" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="结算标准：" prop="settleStandard">
                    <el-input placeholder="请输入质控标准" v-model="taskForm.settleStandard" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="demo-drawer__footer">
            <el-button @click="cancelForm">取 消</el-button>
            <el-button type="primary" @click="submitForm('taskRuleForm')" :loading="loading">{{
              loading ? '提交中 ...' : '确 定'
            }}</el-button>
          </div>
        </div>
        <div class="right px-4 bg-card-bg-gray" :style="{ width: '290px',flex:'none'}">
          <div :style="{ overflow:'auto',height:'calc(100vh - 78px)' }">
            <Advert></Advert>
          </div>
        </div>
      </div>
      
    </el-drawer>
    <over-mask
      :dialogVisible="dialVisible"
      @handleClose="
        () => {
          dialVisible = false
        }
      "
    ></over-mask>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      append-to-body
      width="30%"
      :before-close="handleDialogClose">
      <span>这尚未开通费用结算，无法设定线上结算，请前往开通</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">取 消</el-button>
        <el-button type="primary" @click="toOpen">去开通</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import OverMask from '@/views/survey/offline/components/overMask/OverMask.vue'
import { putOfflineTask } from '@/api/wenjuan/offline.js' //编辑任务API
import { plCreat } from '@/api/wenjuan/addList.js' // 添加任务API
import store from '@/store'
import Advert from '@/components/interview/advert/index.vue'

export default {
  components: { OverMask, Advert },
  props: ['visible', 'rowData', 'type', 'proxyType'],
  watch: {
    visible: {
      handler: function (value) {
        console.log('value', this.rowData)
        const val = JSON.parse(JSON.stringify(this.rowData))
        if (value === true && this.type === 'edit') {
          this.btnChecked = val.settleMethod?this.btnCheckedMap[val.settleMethod]:'online'
          this.taskForm = {
            executorName: val.executorName,
            executorPhone: val.executorPhone,
            executionName: val.executionName,
            executionValidateTo: val.executionValidateTo,
            executionDescription: val.executionDescription,
            executionRequirement: val.executionRequirement,
            qualityControlStandard: val.qualityControlStandard,
            settleStandard: val.settleStandard,
            settleMethod: val.settleMethod || 0,
            settleMode: val.settleMode,
            settleRule: val.settleRule || {
              unitPriceYuan: undefined, //单价 多少元/天  多少元/份
              expectedQuantity: undefined, // 数量 多少份 | 多少天
              tiers: [
                {
                  quantityLowerBound: 0,
                  quantityUpperBound: undefined,
                  unitPriceYuan: undefined
                }
              ]
            }
          }
        } else if (value === true && this.type === 'add') {
          this.taskForm = {
            executorName: this.rowData.executorName,
            executorPhone: this.rowData.executorPhone,
            executionName: '',
            executionValidateTo: null,
            executionDescription: '',
            executionRequirement: '',
            qualityControlStandard: '',
            settleStandard: '',
            settleMethod: 0,
            settleMode: '',
            settleRule: {
              unitPriceYuan: undefined, //单价 多少元/天  多少元/份
              expectedQuantity: undefined, // 数量 多少份 | 多少天
              tiers: [
                {
                  quantityLowerBound: 0,
                  quantityUpperBound: undefined,
                  unitPriceYuan: undefined
                }
              ]
            }
          }
        }
      },
      deep: false
    },
    'taskForm.settleRule.tiers': {
      handler: function (value) {
        console.log(value)
        const cloneValue = JSON.parse(JSON.stringify(value))
        // cloneValue
        cloneValue.forEach((it, i, arr) => {
          console.log(it)
          if (i > 0) {
            it.quantityUpperBound = arr[i - 1].quantityUpperBound + 1
          }
        })
        console.log(cloneValue)
        // this.taskForm.settleRule.tiers = [];
      },
      deep: true
    }
  },
  computed: {
    totalPriceYuan() {
      if (this.taskForm.settleRule.expectedQuantity && this.taskForm.settleRule.unitPriceYuan) {
        return (this.taskForm.settleRule.expectedQuantity * this.taskForm.settleRule.unitPriceYuan).toFixed(2)
      } else {
        return 0
      }
    },
    totalSaleYuan() {
      if (this.taskForm.settleRule.expectedQuantity && this.taskForm.settleRule.unitPriceYuan) {
        return ((1 + this.accRate * 1) * (this.taskForm.settleRule.expectedQuantity * this.taskForm.settleRule.unitPriceYuan)).toFixed(2)
      } else {
        return 0
      }
    },
    accountingRateVal() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '6.5%' : `${accountingRate}%`
    },
    accRate() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '0.065' : (accountingRate / 100).toFixed(3)
    }
  },
  data() {
    const cursomVaild = (rule, value, callback) => {
      if (index > 0) {
        if (value < this.taskForm.ladderSettlement[index - 1].endAmount * 1 + 1) {
          callback(new Error('当前数量必须大于起始份数'))
        } else {
          callback()
        }
      } else {
        if (value < this.taskForm.ladderSettlement[index].startAmount) {
          callback(new Error('当前数量必须大于起始份数'))
        } else {
          callback()
        }
      }
    }
    return {
      dialogVisible: false,
      btnChecked: 'online',
      settleMethodMap: {
        'online':0,
        'offline':1,
        'neednot':2
      },
      btnCheckedMap: {
        0:'online',
        1:'offline',
        2:'neednot'
      },
      isOpen: false,
      formLabelWidth: 120,
      loading: false,
      dialVisible: false,
      taskForm: {
        executorName: '',
        executorPhone: '',
        executionName: '',
        executionValidateTo: null,
        executionDescription: '',
        executionRequirement: '',
        qualityControlStandard: '',
        settleStandard: '',
        settleMethod: 0,
        settleMode: 1,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      },
      rules: {
        executionName: [{ type: 'string', required: true, message: '请输入任务名称', trigger: 'change' }],
        settleMode: [{ required: true, message: '请选择结算方式', trigger: 'change' }],
        executionValidateTo: [{ required: true, message: '请选择截止时间', trigger: 'change' }]
      }
    }
  },
  methods: {
    handleDialogClose() {
      this.dialogVisible = false
    },
    toOpen() {
      this.dialogVisible = false
      window.open(
        `${window.location.origin + process.env.VUE_APP_PRE_URL}/#/cost-settlement`
      )
    },
    changeSettleMethod(btnType) {
      this.btnChecked = btnType
      this.taskForm.settleMethod = this.settleMethodMap[btnType]
      this.changeSettlementType(1)
    },
    // 监听input-number值的变化
    currentInputNumber(val, item, currentIndex) {
      const baseSettleRule = JSON.parse(JSON.stringify(this.taskForm.settleRule))
      baseSettleRule.tiers.forEach((it, i, arr) => {
        if (i > currentIndex) {
          it.quantityUpperBound = arr[i - 1].quantityUpperBound + 1
        }
      })
      this.taskForm.settleRule = {
        ...this.taskForm.settleRule,
        tiers: baseSettleRule.tiers
      }
    },
    // 切换结算方式
    changeSettlementType(val) {
      console.log(val)
      this.$refs['taskRuleForm'].clearValidate()
      this.taskForm = {
        ...this.taskForm,
        settleMode: val,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      }
    },
    handleSettlement(type, index) {
      console.log(type)
      if (type === 'add') {
        const validateArr = []
        this.taskForm.settleRule.tiers.forEach((it, i) => {
          validateArr.push(`settleRule.tiers[${i}].quantityUpperBound`)
          validateArr.push(`settleRule.tiers[${i}].unitPriceYuan`)
        })
        let validFlag = false
        validateArr.forEach(item => {
          this.$refs['taskRuleForm'].validateField(
            validateArr,
            valid => (validFlag = valid ? false : true) // 定义是否通过表单验证
          )
        })
        if (validFlag) {
          if (this.taskForm.settleRule.tiers.length < 5) {
            const lastTiers = this.taskForm.settleRule.tiers[this.taskForm.settleRule.tiers.length - 1]
            const lastObj = { quantityUpperBound: lastTiers.quantityUpperBound, unitPriceYuan: lastTiers.unitPriceYuan }

            const flagDouble = Object.values(lastObj).includes(undefined)
            if (flagDouble) {
              this.$message.error('请完善表单项')
              return
            }
            const cloneLadderSettlement = this.taskForm.settleRule.tiers
            cloneLadderSettlement.push({
              quantityLowerBound: '',
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            })
            this.taskForm.settleRule.tiers = cloneLadderSettlement
          } else {
            this.$message.error('最多只能添加5条数据')
          }
        } else {
          this.$message.error('请完善表单项')
        }
      } else if (type === 'remove') {
        const cloneLadderSettlement = this.taskForm.settleRule.tiers

        this.taskForm.settleRule.tiers = cloneLadderSettlement.filter((it, i) => index !== i)
      }
    },
    cancelForm(formName) {
      // this.$refs['taskRuleForm'].resetFields();
      console.log(this.$refs['taskRuleForm'].fields)
      this.$emit('callbackClose', false)
    },
    customCloseDrawer() {
      this.$emit('callbackClose', false)
    },
    submitForm(formName) {
      if(!this.isOpen&&this.taskForm.settleMethod==0) {
        this.$message({
          message: '尚未开通费用结算，无法设定线上结算',
          type: 'warning'
        });
        return
      }   
      this.$refs[formName].validate(valid => {
        if (valid) {
          let postData = {}
          if (this.taskForm.settleMode === 3) {
            const cloneLadderSettlement = [...this.taskForm.settleRule.tiers]
            cloneLadderSettlement.forEach((it, i, arr) => {
              if (i > 0) {
                it.quantityLowerBound = arr[i - 1].quantityUpperBound * 1
              }
            })
            postData = {
              ...this.taskForm,
              settleRule: {
                ...this.taskForm.settleRule,
                tiers: cloneLadderSettlement
              }
            }
            // postData.ladderSettlement =cloneLadderSettlement;
          } else {
            postData = { ...this.taskForm }
          }
          if (this.type === 'add') {
            plCreat([
              {
                ...postData,
                surveyId: this.rowData.surveyId,
                executionBy: this.rowData.executionBy,
                id: this.rowData.id,
                status: this.rowData.status,
                entrustTaskId: this.$route.query.taskId || '',
                type: this.proxyType || ''
              }
            ]).then(({ data }) => {
              if (data.code === 0) {
                this.$message.success('添加成功')
                this.$emit('callbackClose', false, 'isSubmit')
              } else {
                this.$message.error(data.msg)
              }
            })
          } else {
            putOfflineTask({
              ...postData,
              surveyId: this.rowData.surveyId,
              executionBy: this.rowData.executionBy,
              id: this.rowData.id,
              status: this.rowData.status,
              entrustTaskId: this.$route.query.taskId || ''
            }).then(({ data }) => {
              if (data.code === 0) {
                this.$message.success('修改成功')
                this.$emit('callbackClose', false, 'isSubmit')
              } else {
                this.$message.error(data.msg)
              }
            })
          }
          console.log('postData:', postData, this.rowData)
        } else {
          console.log('error submit!!', valid)
          return false
        }
      })
    }
  },
  created() {
    console.log(123)
  },
  mounted() {
    this.isOpen = store.getters.settlementType !== 1
  }
}
</script>
<style lang="scss" scoped>
.demo-drawer__content {
  padding: 30px;
  height: calc(100vh - 170px);
  overflow: auto;
  .settlementType-style {
    .is-require-task {
      .el-form-item__label {
        &::before {
          content: '*';
          color: #e34152;
          margin-right: 4px;
        }
      }
    }
    .flex-box {
      display: flex;
      position: relative;
      & > span {
        line-height: 32px;
        margin-left: 8px;
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        font-weight: 400;
        font-family: PingFangSC-Regular;
      }
      .pos-abs-box {
        position: absolute;
        display: flex;
        justify-content: flex-end;
        width: 88px;
        padding-right: 12px;
        i {
          content: '*';
          color: #e34152;
          margin-right: 4px;
        }
      }
    }
    margin-bottom: 16px;
    padding: 12px;
    background-color: rgba(242, 242, 242, 0.624);
    .el-form-item {
      margin-bottom: 8px;
      .el-input-number {
        width: 88px;
        background: #f2f5fa;
        .el-input__inner {
          padding-left: 5px !important;
          padding-right: 25px !important;
        }
      }
      .el-input-number.is-controls-right .el-input__inner {
        background: #f2f5fa;
      }
      .el-input.is-disabled .el-input__inner {
        border-color: rgba(221, 221, 221, 1);
      }
      .el-input-number__decrease,
      .el-input-number__increase {
        background: #f2f5fa;
        .el-icon-arrow-down,
        .el-icon-arrow-up {
          color: rgba(0, 0, 0, 0.65);
          border-color: rgba(221, 221, 221, var(--tw-border-opacity));
        }
      }
    }
    .btn-style {
      margin-left: 5px;
    }
    .settlement-tips {
      margin-left: 100px;
      font-size: 12px;
      margin-bottom: 8px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
      .el-button {
        font-size: 12px;
      }
      &.left-0 {
        margin-left: 0;
        margin-bottom: 0;
      }
    }
    .flex-settlement {
      display: flex;
      margin-bottom: 5px;
      align-items: center;
      .settlement-tips {
        margin-bottom: 0;
      }
      .el-form-item {
        margin-bottom: 0;
      }
      .el-input-number {
        width: 88px;
        background: #f2f5fa;
      }
      span {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .icon-wrap {
      margin-left: 4px;
      .ico-tips {
        color: #6c748a;
      }
    }
  }
}
.demo-drawer__footer {
  padding-right: 30px;
  padding-top: 9px;
  height: 50px;
  background: #fff;
  border-top: 1px solid #f5f5f5;
  text-align: right;
}
</style>
<style lang="scss" scoped>
  .inline-block{
    position: relative;
    
  }
  .btn-box {
    @apply flex justify-center;
    padding: 10px;
    min-height: 106px;
    width: 230px;
    border-radius: 2px;
    cursor: pointer;
    line-height: 16px;
    position: relative;
    .position-checkbox{
      position: absolute;
      right: 0;
      top: -2px;
    }
  &.btn1 {
    border: 1px solid #cccccc;
  }
  &.btn2 {
    border: 1px solid #cccccc;
    margin-left: 12px;
  }
  &.btn1.btn-checked,
  &.btn2.btn-checked {
    background: rgba(39,117,232,0.10);
    border: 1px solid var(--theme-color) !important;
  }
  .tujian {
    border: 1px solid #FAAD14;
    border-radius: 8px;
    width: 34px;
    height: 16px;
    font-weight: 500;
    font-size: 12px;
  }
}
// .btn-checked div {
//   div {
//     color: #2775e8 !important;
//   }
//   i {
//     color: #2775e8 !important;
//   }
// }
.btn-box:hover {
  &.btn1,
  &.btn2 {
    background: rgba(39,117,232,0.10);
    border: 1px solid var(--theme-color) !important;
    // div {
    //   div {
    //     color: #2775e8 !important;
    //   }
    //   i {
    //     color: #2775e8 !important;
    //   }
    // }
  }
}
</style>